import { MathUtils, Rectangle } from '@printu/geom';
import { ViewportActionCreators } from '@printu/viewport';
import { getPageBleedBox } from 'app/stores/project/page';
import { getCurrentPage, getPage, getPageImage } from 'app/stores/selectors';
class InvalidSizeError extends Error {
    constructor() {
        super('Invalid image size');
    }
}
export const updateScaleMode = (dispatch, getState) => {
    const state = getState();
    // prevent overscaling
    // TODO: at this point `canvas` can be empty i.e. when pasting image right after starting application
    const { notYetMounted, virtual: virtualRect, canvas: canvasRect, } = state.viewport;
    if (notYetMounted === true) {
        return;
    }
    if (Rectangle.equal(virtualRect, Rectangle.EMPTY) ||
        Rectangle.equal(canvasRect, Rectangle.EMPTY)) {
        return;
    }
    const fitScale = MathUtils.getFitScale(virtualRect.width, virtualRect.height, canvasRect.width, canvasRect.height);
    // clear any fit
    dispatch(ViewportActionCreators.setFitScale(false));
    if (MathUtils.isZero(fitScale) || fitScale > 1) {
        dispatch(ViewportActionCreators.setMode('none'));
        dispatch(ViewportActionCreators.setFitScale(1));
    }
    else {
        dispatch(ViewportActionCreators.setMode('fit'));
    }
};
export const updateViewport = (pageId, dispatch, getState) => {
    const state = getState();
    const page = pageId ? getPage(state, pageId) : getCurrentPage(state);
    if (!page) {
        return;
    }
    const image = getPageImage(state, page.id);
    const virtualRect = getPageBleedBox(page, image);
    if (MathUtils.isZero(virtualRect.width) ||
        MathUtils.isZero(virtualRect.height)) {
        throw new InvalidSizeError();
    }
    dispatch(ViewportActionCreators.setVirtualRect(virtualRect));
    updateScaleMode(dispatch, getState);
};
